import { AccountApi } from 'swagger/apis/account-api';
import OpenApiConfiguration from 'api/OpenApiConfiguration';
import { useAuthQuery } from 'utils/queryHooks';
import { BoatsApi } from 'swagger/apis/boats-api';
import { useMutation } from 'react-query';
import { DomesticV2BoatsIdDeleteRequest } from 'swagger/models';

const accountApi = new AccountApi(OpenApiConfiguration);
const boatsApi = new BoatsApi(OpenApiConfiguration);

export const useListMyBoatsQuery = (page: number) =>
  useAuthQuery(['myBoats', page], () => accountApi.domesticV2MeBoatsGet(page));

export const useGetMyBoatsQuery = (page: number) =>
  useAuthQuery(['myBoats', page], () => accountApi.domesticV3MeBoatsGet(10, page));

export const useBoatIsDeletableMutation = () =>
  useMutation((boatId: string) => boatsApi.domesticV2BoatsIdDeletableGet(boatId));

export const useDeleteBoatMutation = () =>
  useMutation(({ boatId, body }: { boatId: string; body: DomesticV2BoatsIdDeleteRequest }) =>
    boatsApi.domesticV2BoatsIdDelete(boatId, body)
  );
